export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  EVENTS: '/events',
  FARM_SHARE: '/farmshareIP',
  TEMP_FARM_SHARE: '/farmshare',
  DETAIL_EQUIPMENT: '/farmshare/:equipmentId',
  PROFILE: '/farmshare/profile',
  ACHIEVEMENTS: '/achievements',
  ABOUT_US: '/about-us',
  CONTACT: '/contact-us',
  RCD: '/rcd',
  RESOURCES: '/resources',
  PRIVACY: '/privacy',
  USER_LIST: '/userlist',
  RESERVATION_LIST: '/reservationlist',
  EQUIPMENT_LIST: '/equipmentlist',
  MY_RESERVATIONS: '/myreservations',
};
